import {clsx} from 'clsx'
import type {ComponentPropsWithoutRef} from 'react'

import styles from './header-grid-cell.module.css'

type HeaderGridCellProps = ComponentPropsWithoutRef<'div'> & {ref?: React.Ref<HTMLDivElement>}

export const HeaderGridCell = ({ref, ...props}: HeaderGridCellProps) => {
  const {className, ...other} = props

  return <div role="columnheader" aria-colspan={1} className={clsx(className, styles.Box)} {...other} ref={ref} />
}

HeaderGridCell.displayName = 'HeaderGridCell'
